// Translation: External > Provider button (Turkish)
export default Object.freeze({
	continueWithProvider: '{{provider}} ile devam et',
	signUpWithProvider: '{{provider}} ile kayıt ol',
	signInWithProvider: '{{provider}} ile giriş yap'
})
